import React, { PureComponent } from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'react-bootstrap-button-loader';
import { Image, Partners } from '../../components/index';
import { get as getContacts, post as postContact, put as putContact } from '../../redux/modules/contacts';

const FORM_NAME = 'GeneralForm';

class ContactsForm extends PureComponent {

  handlerSubmit(values) {
    const { getContactsAction, putContactAction, postContactAction, contactType, toogle } = this.props;
    const newData = { ...values };
    newData.type = contactType;
    if (newData.id > 0) {
      return putContactAction(newData.id, newData).then(() => {
        toogle();
        getContactsAction();
      });
    } else {
      return postContactAction(newData).then(() => {
        toogle();
        getContactsAction();
      });
    }

  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <form
        className="planet-form"
        onSubmit={handleSubmit(this.handlerSubmit.bind(this))}>

        <section>
          <h3>Partners</h3>
          <Partners/>
        </section>
        <Field name="image" component={Image}/>
        <div className="clearfix"></div>
        <div className="col-lg-12 text-right form-buttons">
          <Button disabled={pristine || submitting} loading={submitting} type="submit"
                  className="btn btn-xl">Save</Button>
          <Button disabled={pristine || submitting} loading={submitting} type="button" className="btn btn-xl"
                  onClick={reset}>Clear</Button>
        </div>
      </form>
    );
  }
}

ContactsForm.propTypes = {};
ContactsForm.defaultProps = {};

ContactsForm = reduxForm({
  form: FORM_NAME
})(ContactsForm);

export default connect(
  (state, props) => {
    return {
      enableReinitialize: true,
      initialValues: props.defaultValues
    };
  },
  (dispatch) => {
    return bindActionCreators({
      getContactsAction: getContacts,
      postContactAction: postContact,
      putContactAction: putContact
    }, dispatch);
  }
)(ContactsForm);



// WEBPACK FOOTER //
// ./src/forms/general/GeneralForm.js